import '../assets/NcCheckboxRadioSwitch-ChIIElUW.css';
import { r as register } from "./_l10n-6dsjYig_.mjs";
register();
